import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { renderToString } from 'react-dom/server';
import {PopupContainer, RealtyItem, InfrastructureItem} from '../Controls/Popup';

class BaseLayer extends React.Component {
  constructor (props) {
    super(props);

    this.lat = Number(props.lat);
    this.lon = Number(props.lon);
    this.zoom = props.zoom;
    this.map = null;

    this.handlerOnLoad = this.handlerOnLoad.bind(this);
  }

  getBounds () {
    return {
      southwest_lng: 0, // юго запад - нижний левый
      southwest_lat: 0,
      northeast_lng: 0, // севего восток - верхний правый
      northeast_lat: 0
    };
  }

  renderSimilar (items) {
    console.log('not implement');
  }

  renderInfrastructure (selectInfrastructureId) {
    console.log('not implement');
  }

  willReceiveInfrastructure (listInfrastructure) {
    console.log('not implement willReceiveInfrastructure');
  }

  handlerOnLoad () {
    const bounds = this.getBounds();

    this.props.onLoad({
      bounds
    });
  }

  componentWillReceiveProps (nextProps, nextContext) {
    try {
      if (!this.props.similar.equals(nextProps.similar)) {
        this.renderSimilar(nextProps.similar.toJS());
      }

      if (!this.props.listInfrastructure.equals(nextProps.listInfrastructure)) {
        this.willReceiveInfrastructure(nextProps.listInfrastructure);
        this.renderInfrastructure(nextProps.selectInfrastructureId);
      }

      if (this.props.selectInfrastructureId !== nextProps.selectInfrastructureId) {
        this.renderInfrastructure(nextProps.selectInfrastructureId);
      }
    } catch (e) {}
  }

  render () {
    return (
      <div>not yet implement</div>
    );
  }
}

BaseLayer.getRealtyPopup = function (items) {
  return renderToString(
    <PopupContainer
      items={items}
      itemElement={RealtyItem}
    />);
};

BaseLayer.getInfrastructurePopup = function (item) {
  return renderToString(
    <PopupContainer
      items={[item.toJS()]}
      itemElement={InfrastructureItem}
    />);
};

BaseLayer.propTypes = {
  onLoad: PropTypes.func,
  zoom: PropTypes.number.isRequired,
  similar: PropTypes.object.isRequired,
  listInfrastructure: PropTypes.object,
  selectInfrastructureId: PropTypes.string,
  lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  lon: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

BaseLayer.defaultProps = {
  listInfrastructure: new Map(),
  selectInfrastructureId: ''
};

export default BaseLayer;



// WEBPACK FOOTER //
// ./src/ui/Maps/Layers/BaseLayer.jsx